import * as React from 'react';
import { CompassIcon } from './Icons';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function Compass(_ref) {
  var azimuth = _ref.azimuth;
  return /*#__PURE__*/_jsx("div", {
    className: styles['compass'],
    children: /*#__PURE__*/_jsx(CompassIcon, {
      rotate: azimuth
    })
  });
}